const decode = (val) => {
  try {
    return atob(val);
  } catch {
    return val;
  }
};

export { decode };
